import Proptypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import pretty from 'pretty'
import { TabsList, Tabs, TabsTrigger, TabsContent } from 'twyne-new.ui'

import Tiptap from 'components/pure/Tiptap';

import CodeEditor from './CodeEditor';

const propTypes = {
  value: Proptypes.string,
  onChange: Proptypes.func,
}

export default function HTMLEditorPreview({ value, onChange, tabSize = 'md', toolbarSize = '' }) {
  const [content, setContent] = useState(value);

  useEffect(() => {
    setContent(value);
  }, [value])

  const handleChange = value => {
    const html = pretty(value)
    setContent(html);
    onChange(html);
  }

  return <Tabs defaultValue='textEditor' size={tabSize}>
    <TabsList>
      <TabsTrigger value='textEditor'>Text</TabsTrigger>
      <TabsTrigger value='aceEditor'>HTML</TabsTrigger>
    </TabsList>
    <TabsContent value='textEditor' className='mt-0'>
      <Tiptap
        content={content}
        onChange={handleChange}
        small={toolbarSize === 'sm'}
        height='200px'
      />
    </TabsContent>
    <TabsContent value='aceEditor' className='mt-0'>
      <CodeEditor
        wrapEnabled
        language='html'
        theme="textmate"
        onChange={handleChange}
        value={content || ''}
        width='100%'
        height="200px"
        className='border-2 twy-border-base'
        editorProps={{ $blockScrolling: true }}
      />
    </TabsContent>
  </Tabs>
}

HTMLEditorPreview.propTypes = propTypes;
